import React from 'react';

const CanceledBox = (props) => {
  return(
  	<div className="CanceledBlock">INSTÄLLD</div>
  );
}

export {CanceledBox}
